import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        openClass: { type: String, default: 'show-u30-2025-menu' }
    }

    toggle() {
        document.body.classList.toggle(this.openClassValue);
        this._update();
    }

    open() {
        document.body.classList.add(this.openClassValue);
        this._update();
    }

    close() {
        document.body.classList.remove(this.openClassValue);
        this._update();
    }

    _update() {
        if (document.body.classList.contains(this.openClassValue)) {
            this.element.setAttribute('aria-expanded', 'true');
            this.element.setAttribute('aria-label', this.labelClosedValue);
        } else {
            this.element.setAttribute('aria-expanded', 'false');
            this.element.setAttribute('aria-label', this.labelOpenedValue);
        }
    }
}
